import {FC, useEffect} from 'react';

import {useLayer} from '../../../libs/shared/ui/src/components/layers/layerContext';

/*
 * Constants.
 */

const appTitle = 'Front';

/*
 * Props.
 */

interface TitleProps {
  badgeValue: number;
}

/*
 * Component.
 */

/** Add the current badge value to the title of the document. */
export const Title: FC<TitleProps> = ({badgeValue}) => {
  const {window} = useLayer();

  useEffect(() => {
    const newTitle = badgeValue > 0 ? `${appTitle} (${badgeValue})` : appTitle;
    window.document.title = newTitle;
  }, [window, badgeValue]);

  return null;
};
